import styled from "styled-components";
import { mediaMax } from "helpers/mediaQueries";

export const Wrapper = styled.div`
  position: relative;
  will-change: transform;

  background: linear-gradient(
    rgb(63, 98, 174) 10%,
    #d77e5d 25%,
    #d77e5d 35%,
    rgb(63, 98, 174) 45%,
    #3f62ae 60%,
    #3f62ae 70%,
    #d77e5d 85%
  );
  ${mediaMax("tabletLandscape")} {
    display: flex;
    flex-direction: column;
    background: linear-gradient(
      rgb(63, 98, 174) 0%,
      rgb(231, 228, 213) 23%,
      rgb(231, 228, 213) 39%,
      rgb(215, 126, 93) 42%,
      rgb(63, 98, 174) 53%,
      rgb(63, 98, 174) 76%,
      rgb(215, 126, 93) 91%
    );
    .fullscreen-image-section {
      margin-bottom: 48px;

      .gatsby-image-wrapper {
        aspect-ratio: 4/3;
      }
    }
    .fullscreen-copy-section {
      order: -1;
    }
  }
`;
